import React from "react";
import { Placeholder, Row, Col } from "react-bootstrap";

function SkeletonDetail({ rows = 6 }) {
  return (
    <Placeholder as="div" animation="glow">
      {Array(rows)
        .fill(null)
        .map((_, i) => (
          <Row key={i} className="mb-2">
            <Col xs={3}>
              <Placeholder xs={8} size="sm" />
            </Col>
            <Col xs={9}>
              <Placeholder xs={i % 2 === 0 ? 6 : 10} size="sm" />
            </Col>
          </Row>
        ))}
    </Placeholder>
  );
}

export default SkeletonDetail;
